import type {
  CityProgressDTO,
  WorldSnapshotDTO
} from "@light-earth/contracts";

const now = Date.now();
const scheduledStart = now + 365 * 24 * 60 * 60 * 1_000;

export const previewWorld: WorldSnapshotDTO = {
  campaignId: "earth-relay-72h",
  campaignName: "72H Earth Relay",
  startsAt: new Date(scheduledStart).toISOString(),
  endsAt: new Date(scheduledStart + 72 * 60 * 60 * 1_000).toISOString(),
  walkers: 0,
  relayPasses: 0,
  citiesLit: 0,
  regionsReached: 0,
  areaSquareKilometers: 0,
  totalSteps: 0,
  stepGoal: 10_000_000,
  missionProgress: 0,
  recentPulses: []
};

export const previewCities: CityProgressDTO[] = [
  city("ca-vancouver", "Vancouver", "Canada", 49.2827, -123.1207),
  city("us-san-francisco", "San Francisco", "United States", 37.7749, -122.4194),
  city("gb-london", "London", "United Kingdom", 51.5072, -0.1276),
  city("fr-paris", "Paris", "France", 48.8566, 2.3522),
  city("ae-dubai", "Dubai", "United Arab Emirates", 25.2048, 55.2708),
  city("sg-singapore", "Singapore", "Singapore", 1.3521, 103.8198),
  city("jp-tokyo", "Tokyo", "Japan", 35.6762, 139.6503),
  city("au-sydney", "Sydney", "Australia", -33.8688, 151.2093)
];

function city(
  id: string,
  name: string,
  countryOrRegion: string,
  latitude: number,
  longitude: number
): CityProgressDTO {
  return {
    id,
    name,
    countryOrRegion,
    latitude,
    longitude,
    level: 1,
    contributors: 0,
    activeToday: 0,
    progress: 0
  };
}
